/* eslint-disable no-unused-vars */
import ManagerService from '_services/rest/modules/manager';

export default {
  state: {
    manager: null,
    managerList: null,
    detachedDistributors: null,
    attachedDistributors: null,
    allAttachedDistributors: null,
  },
  mutations: {
    setManagerList(state, response) {
      state.managerList = response;
    },
    setManager(state, response) {
      state.manager = response;
    },
    setDetachedDistributors(state, response) {
      state.detachedDistributors = response;
    },
    setAttachedDistributors(state, response) {
      state.attachedDistributors = response;
    },
    setAllAttachedDistributors(state, response) {
      state.allAttachedDistributors = response;
    },
  },
  actions: {
    getManagerList({ commit }, params) {
      return ManagerService.getList(params)
        .then(response => {
          commit('setManagerList', response);
        });
    },

    getManager({ commit }, params) {
      return ManagerService.getManagerById(params)
        .then(manager => {
          commit('setManager', manager);
          return manager;
        })
        .catch(error => {
          throw error.message;
        });
    },

    editManager({ commit }, params) {
      return ManagerService.save(params);
    },

    deleteManager({ commit }, params) {
      return ManagerService.delete(params);
    },

    getManagerSupervisors({ commit }, params) {
      if (!params.search && params.group === 'attached') {
        return ManagerService.getSupervisorDistributors({
          ...params,
          take: 0,
        }).then(response => {
          if (params.page === 1) commit('setAllAttachedDistributors', response);
          commit('setAttachedDistributors', response);
          return response;
        });
      }

      return ManagerService.getSupervisorDistributors(params).then(response => {
        if (params.group && params.group === 'attached') {
          if (!params.search) {
            commit('setAllAttachedDistributors', response);
          }
          commit('setAttachedDistributors', response);
          return response;
        }
        commit('setDetachedDistributors', response);
        return response;
      });
    },

    syncAttacherManagerSupervisors({ commit }, { attachedDistributor, id }) {
      const supervisors = attachedDistributor.map(supervisor => ({
        id: supervisor.id,
      }));
      commit('setAllAttachedDistributors', {
        total_items: attachedDistributor.length,
        pages: Math.ceil(attachedDistributor.length / 10),
        list: attachedDistributor
      });
      return ManagerService.syncResellers({
        id,
        supervisors,
      });
    },
  },
};
